import React, { Fragment, useState, useEffect } from "react";
import Swiper from "react-id-swiper";
import SectionTitleSeven from "../../components/section-title/SectionTitleSeven";
import CoachSingle from "../../components/brand-logo/CoachSingle";
import axios from "axios";
import { API_ROOT } from "../../configs/env-vars";

const CoachSlider = ({ spaceBottomClass, spaceTopClass }) => {
  const [coaches, setCoaches] = useState([])
  const getCoaches = async () => {
    const result = await axios(
      `${API_ROOT}/coaches-profile/unique`
    );
    setCoaches(result.data.results)
  }
  useEffect(() => {

  getCoaches()
  }, [])
  const settings = {
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    grabCursor: true,
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      640: {
        slidesPerView: 3,
      },
      320: {
        slidesPerView: 2,
      },
    },
  };

  // const getCoaches = (coachesList) => {
  //   let newList = [];
  //   coachesList.map((item) => {
  //     newList.filter((fitem) => {
  //       return item.image == fitem.image;
  //     }).length <= 0
  //       ? newList.push(item)
  //       : (item = item);
  //   });
  //   return newList;
  // };

  return (
    (coaches && coaches.length > 0) ?
    <div
      className={`brand-logo-area ${
        spaceBottomClass ? spaceBottomClass : ""
      }  ${spaceTopClass ? spaceTopClass : ""}`}
    >
      <div className="container">
        <SectionTitleSeven
          titleText="Meet Our Team"
          positionClass="text-center"
          spaceClass="mb-50"
          borderClass="no-border"
        />
        <div className="brand-logo-active">
          <Swiper {...settings}>
            
              {coaches.map((single, key) => {
                return (
                  <CoachSingle
                    data={single}
                    key={key}
                    sliderClassName="swiper-slide"
                    spaceBottomClass="mb-30"
                  />
                );
              })}
          </Swiper>
        </div>
      </div>
    </div>
    :
    null
  );
};


export default CoachSlider;
